const settingsTutorial = {
  module: 'settings',
  moduleName: 'Settings',
  steps: [
    {
      target: '.page-title, .admin-settings, .settings-page',
      position: 'bottom',
      title: 'Site Settings',
      description: 'Configure your VMS, access control, intercoms, and other integrations.',
    },
  ],
};

export default settingsTutorial;
